'use strict';

module.exports = function split(numberOfGroups) {
  var itemsPerGroup = Math.round(this.items.length / numberOfGroups);

  var items = JSON.parse(JSON.stringify(this.items));
  var collection = [];

  for (var iterator = 0; iterator < numberOfGroups; iterator += 1) {
    collection.push(items.splice(0, itemsPerGroup));
  }

  return collection;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/split.js
// module id = 1212
// module chunks = 2